function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-random-grad-programs\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.74,28.24H13.26a1.13,1.13,0,1,1,0-2.25H26.74a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.74,33.29H13.26a1.13,1.13,0,1,1,0-2.25H26.74a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.26,23.7a.86.86,0,0,1-.5-.17l-3.7-2.74A1,1,0,0,1,.68,20a1,1,0,0,1,.38-.8l3.69-2.73a.85.85,0,0,1,1.18.17.85.85,0,0,1-.18,1.18L2.81,20l2.95,2.18a.84.84,0,0,1-.5,1.52Zm-3.2-3.15Zm0-1.11h0Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.74,23.7a.84.84,0,0,1-.5-1.52L37.19,20l-2.94-2.18a.85.85,0,0,1-.18-1.18.85.85,0,0,1,1.18-.17l3.69,2.73a1,1,0,0,1,.38.8,1,1,0,0,1-.38.79l-3.7,2.74A.86.86,0,0,1,34.74,23.7Zm3.2-3.15h0Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20,14.7a1.79,1.79,0,0,1-.51-.07L6.78,11a1.05,1.05,0,0,1,0-2L19.46,5.27a2,2,0,0,1,1.08,0L33.22,8.94a1.05,1.05,0,0,1,0,2L20.51,14.63A1.79,1.79,0,0,1,20,14.7ZM9.66,10l10.32,3,10.36-3L20.05,7l-.34-.85L20,7Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20,21.39a1.27,1.27,0,0,1-.72-.22,12.9,12.9,0,0,0-6.63-2.11,1.06,1.06,0,0,1-1-1v-6.3a.89.89,0,1,1,1.77,0v5.61A14.92,14.92,0,0,1,20,19.52a14.92,14.92,0,0,1,6.62-2.2V11.71a.89.89,0,1,1,1.77,0V18a1.05,1.05,0,0,1-1,1,12.9,12.9,0,0,0-6.63,2.11A1.27,1.27,0,0,1,20,21.39Z",
  fill: "#231f20"
});

function SvgCmsRandomGradPrograms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsRandomGradPrograms;